/* eslint-disable no-console */
import React, { useMemo } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Descope, useSession } from '@descope/react-sdk';
import { Stack } from '@mui/material';
import { jwtDecode } from 'jwt-decode';

import BackdropLoader from '@/components/BackdropLoader';
import { useSnackbar } from '@/hooks/useSnackbar';
import { ROUTER_PATHS } from '@/root/linker';

const FALLBACK_FLOW_ID = 'midot-login-two-factor-easy-v3';
const flowId = process.env.VITE_DESCOPE_FLOW_ID || FALLBACK_FLOW_ID;
const LAST_LOGIN_EMAIL_KEY = 'last-login-email';
const LAST_OTP_DONE_KEY = 'last-otp-done';
const LAST_OTP_METHOD_KEY = 'last-otp-method';

const Login = () => {
  const { isAuthenticated, isSessionLoading } = useSession();
  const { showMessage } = useSnackbar();

  const navigate = useNavigate();

  const form = useMemo(
    () => ({
      prevEmail: localStorage.getItem(LAST_LOGIN_EMAIL_KEY) || '',
      lastOtpDone: parseInt(localStorage.getItem(LAST_OTP_DONE_KEY) || '0', 10),
      lastOtpMethod: localStorage.getItem(LAST_OTP_METHOD_KEY) || ''
    }),
    []
  );

  if (isSessionLoading) {
    return <BackdropLoader />;
  }

  if (isAuthenticated) {
    return <Navigate to={ROUTER_PATHS.HOME} />;
  }

  return (
    <Stack minHeight="100vh" justifyContent="center" alignItems="center" sx={{ bgcolor: 'primary.50' }}>
      <Descope
        flowId={flowId!}
        form={form}
        onSuccess={response => {
          navigate(ROUTER_PATHS.HOME);
          const email = response?.detail?.user?.email;
          const token = response?.detail?.sessionJwt;
          const parsedToken = jwtDecode<{ lastOtpDone: number; lastOtpMethod: string }>(token);
          if (email) {
            localStorage.setItem(LAST_LOGIN_EMAIL_KEY, email);
          }
          if (parsedToken?.lastOtpDone) {
            localStorage.setItem(LAST_OTP_DONE_KEY, `${parsedToken.lastOtpDone}`);
          }
          if (parsedToken?.lastOtpMethod) {
            localStorage.setItem(LAST_OTP_METHOD_KEY, parsedToken.lastOtpMethod);
          }
        }}
        onError={e => {
          console.error(e);
          showMessage('login.error');
        }}
      />
    </Stack>
  );
};

export default Login;
